module.exports = __webpack_public_path__ + "img/works_procurement_system_app_2@4x.a7bca9eb.png";